// extracted by mini-css-extract-plugin
export default {"contentWrapper":"ActivityListPage_contentWrapper__W+dCt"};